import { Play, RotateCcw, Trophy, Target, Skull, User, CheckCircle, XCircle } from 'lucide-react';
import React, { useState, useEffect, useMemo } from 'react';
import './App.css';
import { createGlobalStyle } from 'styled-components';

// --- KONSTANTER ---
// Bytter ut den skarpe rødfargen med en mykere rosatone
const PLAYER_COLORS = ['#fa164fff', '#2563eb', '#059669', '#d97706', '#7c3aed', '#0891b2'];
const PLAYER_HIGHLIGHT_COLORS = ['#10d853ff', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#0ea5e9'];
const PLAYER_AVATARS = ['👤', '⭐', '💡', '🌍', '⚡', '👑', '💎', '❤️', '💧', '🔥'];

const EVENT_PACKS = {
  ALLMENN_HISTORIE: {
  name: 'Allmenn historie',
  backgroundStyle: 'linear-gradient(to bottom, #f3f1e9, #e9e6dd)', // Papirfarge
  background: `
    <div class="map-lines"></div>
    <div class="compass-rose">🧭</div>
    <div class="history-hourglass">⏳</div> 
  `,
    events: [
  { event: "Pyramidene i Egypt bygges", year: -2500, category: "Antikken" },
  { event: "Kristi fødsel", year: 0, category: "Antikken" },
  { event: "Det vestromerske riket faller", year: 476, category: "Antikken" },
  { event: "Vikingtiden begynner", year: 793, category: "Middelalder" },
  { event: "Harald Hårfagre samler Norge", year: 872, category: "Norsk historie" },
  { event: "Kristendommen innføres i Norge", year: 1000, category: "Norsk historie" },
  { event: "Slaget på Stiklestad", year: 1030, category: "Norsk historie" },
  { event: "Første korstog", year: 1095, category: "Middelalder" },
  { event: "Svartedauden kom til Norge", year: 1349, category: "Middelalder" },
  { event: "Den norske union med Danmark begynner", year: 1380, category: "Norsk historie" },
  { event: "Gutenberg finner opp boktrykkerkunsten", year: 1440, category: "Oppfinnelser" },
  { event: "Columbus 'oppdager' Amerika", year: 1492, category: "Oppdagelser" },
  { event: "Leonardo da Vinci maler Mona Lisa", year: 1503, category: "Kunst" },
  { event: "Magellan starter første verdensomseiling", year: 1519, category: "Oppdagelser" },
  { event: "Shakespeares død", year: 1616, category: "Litteratur" },
  { event: "Isaac Newton publiserer 'Principia'", year: 1687, category: "Vitenskap" },
  { event: "Den franske revolusjon begynner", year: 1789, category: "Politikk" },
  { event: "Norge får egen grunnlov på Eidsvoll", year: 1814, category: "Norsk historie" },
  { event: "Napoleon tapte ved Waterloo", year: 1815, category: "Krig" },
  { event: "Den første jernbanen åpnes", year: 1825, category: "Teknologi" },
  { event: "Darwin publiserer 'Om artenes opprinnelse'", year: 1859, category: "Vitenskap" },
  { event: "Alexander Graham Bell finner opp telefonen", year: 1876, category: "Oppfinnelser" },
  { event: "Edison finner opp lyspæra", year: 1879, category: "Oppfinnelser" },
  { event: "Eiffeltårnet bygges", year: 1889, category: "Arkitektur" },
  { event: "Brødrene Wright flyr første gang", year: 1903, category: "Teknologi" },
  { event: "Union med Sverige oppløses", year: 1905, category: "Norsk historie" },
  { event: "Roald Amundsen når Sydpolen", year: 1911, category: "Oppdagelser" },
  { event: "Titanic synker", year: 1912, category: "Katastrofer" },
  { event: "Kvinner får stemmerett i Norge", year: 1913, category: "Norsk historie" },
  { event: "Første verdenskrig begynner", year: 1914, category: "Krig" },
  { event: "Første verdenskrig slutter", year: 1918, category: "Krig" },
  { event: "Alexander Fleming oppdager penicillin", year: 1928, category: "Medisin" },
  { event: "Børskrakket på Wall Street", year: 1929, category: "Økonomi" },
  { event: "Hitler kommer til makten i Tyskland", year: 1933, category: "Politikk" },
  { event: "Andre verdenskrig begynner", year: 1939, category: "Krig" },
  { event: "Tyskland invaderer Norge", year: 1940, category: "Norsk historie" },
  { event: "Japan angriper Pearl Harbor", year: 1941, category: "Krig" },
  { event: "D-dagen: Normandie-landgangen", year: 1944, category: "Krig" },
  { event: "Atombomber slippes over Japan", year: 1945, category: "Krig" },
  { event: "Andre verdenskrig slutter", year: 1945, category: "Krig" },
  { event: "FN etableres", year: 1945, category: "Politikk" },
  { event: "Israel etableres som stat", year: 1948, category: "Politikk" },
  { event: "NATO etableres", year: 1949, category: "Politikk" },
  { event: "Korean-krigen begynner", year: 1950, category: "Krig" },
  { event: "DNA-strukturen oppdages", year: 1953, category: "Vitenskap" },
  { event: "Sputnik sendes opp", year: 1957, category: "Romfart" },
  { event: "Berlinmuren bygges", year: 1961, category: "Politikk" },
  { event: "John F. Kennedy skutt", year: 1963, category: "Politikk" },
  { event: "Martin Luther King holder 'I have a dream'-talen", year: 1963, category: "Borgerrettigheter" },
  { event: "Neil Armstrong går på månen", year: 1969, category: "Romfart" },
  { event: "Olje oppdages i Nordsjøen", year: 1969, category: "Norsk historie" },
  { event: "Woodstock-festivalen", year: 1969, category: "Kultur" },
  { event: "Vietnam-krigen slutter", year: 1975, category: "Krig" },
  { event: "Apple lanserer første datamaskin", year: 1976, category: "Teknologi" },
  { event: "Tsjernobyl-ulykken", year: 1986, category: "Katastrofer" },
  { event: "Berlinmuren faller", year: 1989, category: "Politikk" },
  { event: "Sovjetunionen oppløses", year: 1991, category: "Politikk" },
  { event: "Internett (www) oppfinnes", year: 1991, category: "Teknologi" },
  { event: "Nelson Mandela blir president i Sør-Afrika", year: 1994, category: "Politikk" },
  { event: "OL i Lillehammer", year: 1994, category: "Norsk historie" },
  { event: "Den andre norske EU-avstemningen", year: 1994, category: "Norsk historie" },
  { event: "Prinsesse Diana dør", year: 1997, category: "Berømtheter" },
  { event: "Terrorangrepet 11. september", year: 2001, category: "Terrorisme" },
  { event: "iPhone lanseres", year: 2007, category: "Teknologi" },
  { event: "Barack Obama blir USAs president", year: 2009, category: "Politikk" },
  { event: "22. juli-angrepene", year: 2011, category: "Norsk historie" },
  { event: "Facebook når 1 milliard brukere", year: 2012, category: "Teknologi" },
  { event: "Brexit-avstemningen", year: 2016, category: "Politikk" },
  { event: "Donald Trump blir USAs president første gang", year: 2017, category: "Politikk" },
  { event: "COVID-19 pandemien begynner", year: 2020, category: "Helse" },
  { event: "Joe Biden blir USAs president", year: 2021, category: "Politikk" }
]
  },
  WW2: {
    name: '2. verdenskrig',
    backgroundStyle: 'linear-gradient(to bottom, #d1d5db, #9ca3af)',
    background: `
      <div class="ww2-planes">
        <div class="plane">✈</div>
        <div class="plane">✈</div>
      </div>
      <div class="ww2-grid"></div>
    `,
    events: [
      { event: "Tyskland invaderer Polen", year: 1939, month: 9, day: 1, category: "Krig" },
      { event: "Storbritannia og Frankrike erklærer krig mot Tyskland", year: 1939, month: 9, day: 3, category: "Krig" },
      { event: "Vinterkrigen starter (Finland-Sovjetunionen)", year: 1939, month: 11, day: 30, category: "Krig" },
      { event: "Tyskland invaderer Danmark og Norge", year: 1940, month: 4, day: 9, category: "Norsk historie" },
      { event: "Tyskland invaderer Frankrike, Belgia, Nederland og Luxembourg", year: 1940, month: 5, day: 10, category: "Krig" },
      { event: "Evakueringen fra Dunkirk", year: 1940, month: 5, day: 26, category: "Krig" },
      { event: "Italia erklærer krig mot Frankrike og Storbritannia", year: 1940, month: 6, day: 10, category: "Krig" },
      { event: "Frankrike kapitulerer", year: 1940, month: 6, day: 22, category: "Krig" },
      { event: "Luftslaget om Storbritannia begynner", year: 1940, month: 7, day: 10, category: "Krig" },
      { event: "Tyskland invaderer Sovjetunionen (Operasjon Barbarossa)", year: 1941, month: 6, day: 22, category: "Krig" },
      { event: "Den atlantiske pakten undertegnes", year: 1941, month: 8, day: 14, category: "Politikk" },
      { event: "Beleiringen av Leningrad begynner", year: 1941, month: 9, day: 8, category: "Krig" },
      { event: "Japan angriper Pearl Harbor", year: 1941, month: 12, day: 7, category: "Krig" },
      { event: "USA erklærer krig mot Japan", year: 1941, month: 12, day: 8, category: "Krig" },
      { event: "Tyskland og Italia erklærer krig mot USA", year: 1941, month: 12, day: 11, category: "Krig" },      
      { event: "Tyske styrker kapitulerer i Stalingrad", year: 1943, month: 2, day: 2, category: "Krig" },    
      { event: "Italia kapitulerer", year: 1943, month: 9, day: 8, category: "Krig" },      
      { event: "D-dagen: Landgangen i Normandie", year: 1944, month: 6, day: 6, category: "Krig" },
      { event: "Paris befris", year: 1944, month: 8, day: 25, category: "Krig" },
      { event: "Ardenneroffensiven begynner", year: 1944, month: 12, day: 16, category: "Krig" },
      { event: "Auschwitz-Birkenau befris av sovjetiske styrker", year: 1945, month: 1, day: 27, category: "Holocaust" },
      { event: "Den røde armé når Berlin", year: 1945, month: 4, day: 16, category: "Krig" },
      { event: "President Roosevelt dør", year: 1945, month: 4, day: 12, category: "Politikk" },
      { event: "Hitler begår selvmord", year: 1945, month: 4, day: 30, category: "Krig" },
      { event: "Tyskland kapitulerer", year: 1945, month: 5, day: 7, category: "Krig" },
      { event: "Frigjøringsdagen i Norge", year: 1945, month: 5, day: 8, category: "Norsk historie" },      
      { event: "Atombomben slippes over Hiroshima", year: 1945, month: 8, day: 6, category: "Krig" },
      { event: "Atombomben slippes over Nagasaki", year: 1945, month: 8, day: 9, category: "Krig" },
      { event: "Japan kapitulerer", year: 1945, month: 8, day: 15, category: "Krig" },
       { event: "Tyskland og Italia danner Aksen", year: 1940, month: 9, day: 27, category: "Politikk" },
      { event: "Anne Frank og familien arresteres i Amsterdam", year: 1944, month: 8, day: 4, category: "Holocaust" },
      { event: "Den norske kongen og regjeringen flykter til London", year: 1940, month: 6, day: 7, category: "Norsk historie" },      
      { event: "Nürnberg-rettsakene begynner", year: 1945, month: 11, day: 20, category: "Rettssaker" },
    ]
  },
  COLD_WAR: {
    name: 'Den kalde krigen (1947-1991)',
  backgroundStyle: 'linear-gradient(120deg, #4b5563, #a14242ff)', 
    background: `
      <div class="cold-war-symbols">
        <div class="star">☭</div>
        <div class="star">★</div>
        <div class="star">$</div>
      </div>
      <div class="cold-war-divide"></div>
    `,
    events: [
      { event: "Truman-doktrinen kunngjøres", year: 1947, month: 3, day: 12, category: "Politikk" },
      { event: "Marshall-planen kunngjøres", year: 1947, month: 6, day: 5, category: "Økonomi" },
      { event: "India blir uavhengig", year: 1947, month: 8, day: 15, category: "Politikk" },
      { event: "Berlinblokaden starter", year: 1948, month: 6, day: 24, category: "Politikk" },
      { event: "Folkerepublikken Kina utropes", year: 1949, month: 10, day: 1, category: "Politikk" },
      { event: "NATO etableres", year: 1949, month: 4, day: 4, category: "Politikk" },
      { event: "Sovjetunionen tester sin første atombombe", year: 1949, month: 8, day: 29, category: "Militært" },
      { event: "Koreakrigen bryter ut", year: 1950, month: 6, day: 25, category: "Krig" },
      { event: "Warsawapakten opprettes", year: 1955, month: 5, day: 14, category: "Politikk" },     
      { event: "NASA opprettes", year: 1958, month: 7, day: 29, category: "Romfart" },
      { event: "Fidel Castro tar makten på Cuba", year: 1959, month: 1, day: 1, category: "Politikk" },
      { event: "Jurij Gagarin blir første menneske i rommet", year: 1961, month: 4, day: 12, category: "Romfart" },    
      { event: "Berlinmuren bygges", year: 1961, month: 8, day: 13, category: "Politikk" },
      { event: "Cubakrisen", year: 1962, month: 10, day: 16, category: "Politikk" },
      { event: "President Kennedy skutt", year: 1963, month: 11, day: 22, category: "Politikk" },      
      { event: "Seks-dagerskrigen", year: 1967, month: 6, day: 5, category: "Krig" },    
      { event: "Martin Luther King Jr. skutt", year: 1968, month: 4, day: 4, category: "Politikk" },
      { event: "Første månelanding", year: 1969, month: 7, day: 20, category: "Romfart" },
      { event: "Yom Kippur-krigen", year: 1973, month: 10, day: 6, category: "Krig" },
      { event: "Vietnamkrigen avsluttes", year: 1975, month: 4, day: 30, category: "Krig" },     
      { event: "Mikhail Gorbatsjov blir leder av Sovjetunionen", year: 1985, month: 3, day: 11, category: "Politikk" },
      { event: "Tsjernobyl-ulykken", year: 1986, month: 4, day: 26, category: "Katastrofer" },
      { event: "Berlinmuren faller", year: 1989, month: 11, day: 9, category: "Politikk" },      
      { event: "Øst- og Vest-Tyskland gjenforenes", year: 1990, month: 10, day: 3, category: "Politikk" },
      { event: "Boris Jeltsin blir president i Russland", year: 1991, month: 6, day: 12, category: "Politikk" },      
      { event: "Sovjetunionen oppløses", year: 1991, month: 12, day: 26, category: "Politikk" },
     { event: "Koreakrigen avsluttes med våpenhvile", year: 1953, month: 7, day: 27, category: "Krig" },
      { event: "Rosa Parks nekter å gi fra seg setet sitt", year: 1955, month: 12, day: 1, category: "Borgerrettigheter" },
      { event: "Robert F. Kennedy skutt", year: 1968, month: 6, day: 5, category: "Politikk" },
      { event: "Woodstock-festivalen", year: 1969, month: 8, day: 15, category: "Kultur" },      
      { event: "John Lennon skutt i New York", year: 1980, month: 12, day: 8, category: "Kultur" },      
      { event: "Fløyelrevolusjonen i Tsjekkoslovakia", year: 1989, month: 11, day: 17, category: "Politikk" },
      { event: "Nelson Mandela løslates fra fengsel", year: 1990, month: 2, day: 11, category: "Politikk" },
      { event: "Gulfkrigen begynner", year: 1991, month: 1, day: 17, category: "Krig" },
      { event: "Oppløsningen av Jugoslavia begynner", year: 1991, month: 6, day: 25, category: "Politikk" },     
    ]
  },
  POST_2000: {
  name: 'Etter år 2000',
  backgroundStyle: 'linear-gradient(to bottom, #0c0a09, #1c1917)', // Mørkere for kontrast
  background: `
    <div class="binary-rain">
      <span>0</span><span>1</span><span>0</span><span>1</span><span>0</span>
      <span>1</span><span>0</span><span>1</span><span>0</span><span>1</span>
      <span>0</span><span>1</span><span>0</span><span>1</span><span>0</span>
      <span>1</span><span>0</span><span>1</span><span>0</span><span>1</span>
    </div>
  `,
    events: [
            { event: "Vladimir Putin blir president i Russland", year: 2000, month: 5, day: 7, category: "Politikk" },
      { event: "Wikipedia lanseres", year: 2001, month: 1, day: 15, category: "Teknologi" },
      { event: "Terrorangrepet 11. september", year: 2001, month: 9, day: 11, category: "Terrorisme" },     
      { event: "Euroen innføres (som kontanter)", year: 2002, month: 1, day: 1, category: "Økonomi" },
      { event: "Irak-krigen begynner", year: 2003, month: 3, day: 20, category: "Krig" },
      { event: "Facebook lanseres", year: 2004, month: 2, day: 4, category: "Teknologi" },      
      { event: "YouTube lanseres", year: 2005, month: 2, day: 14, category: "Teknologi" },
      { event: "Orkanen Katrina", year: 2005, month: 8, day: 29, category: "Katastrofer" },
      { event: "Twitter lanseres", year: 2006, month: 3, day: 21, category: "Teknologi" },
      { event: "Den første iPhonen lanseres", year: 2007, month: 1, day: 9, category: "Teknologi" },       
      { event: "Barack Obama blir president i USA", year: 2009, month: 1, day: 20, category: "Politikk" },
      { event: "Den arabiske våren begynner i Tunisia", year: 2010, month: 12, day: 17, category: "Politikk" },      
      { event: "Osama bin Laden drept", year: 2011, month: 5, day: 2, category: "Terrorisme" },
      { event: "22. juli-angrepene i Norge", year: 2011, month: 7, day: 22, category: "Norsk historie" },      
      { event: "Russland annekterer Krim", year: 2014, month: 3, day: 18, category: "Krig" },
      { event: "IS utroper kalifat i Irak og Syria", year: 2014, month: 6, day: 29, category: "Terrorisme" },      
      { event: "Terrorangrepene i Paris (Charlie Hebdo)", year: 2015, month: 1, day: 7, category: "Terrorisme" },       
      { event: "Brexit-avstemningen i Storbritannia", year: 2016, month: 6, day: 23, category: "Politikk" },
      { event: "Donald Trump velges til president i USA første gang", year: 2016, month: 11, day: 8, category: "Politikk" },      
      { event: "#MeToo-bevegelsen tar fart", year: 2017, month: 10, day: 15, category: "Samfunn" },     
      { event: "COVID-19 oppdages i Wuhan, Kina", year: 2019, month: 12, day: 31, category: "Helse" },
      { event: "Australia rammes av massive skogbranner", year: 2020, month: 1, day: 1, category: "Katastrofer" },      
      { event: "George Floyd drept, utløser Black Lives Matter-protester", year: 2020, month: 5, day: 25, category: "Samfunn" },
      { event: "Joe Biden velges til president i USA", year: 2020, month: 11, day: 7, category: "Politikk" },
      { event: "Stormingen av Capitol Hill i USA", year: 2021, month: 1, day: 6, category: "Politikk" },
      { event: "Taliban tar kontroll over Afghanistan", year: 2021, month: 8, day: 15, category: "Krig" },
      { event: "Russlands fullskala invasjon av Ukraina", year: 2022, month: 2, day: 24, category: "Krig" },
      { event: "Dronning Elizabeth II dør", year: 2022, month: 9, day: 8, category: "Politikk" },
      { event: "ChatGPT lanseres", year: 2022, month: 11, day: 30, category: "Teknologi" },      
      { event: "Hamas-angrepet på Israel", year: 2023, month: 10, day: 7, category: "Terrorisme" },      
    { event: "PlayStation 2 lanseres i Europa", year: 2000, month: 11, day: 24, category: "Teknologi" },      
      { event: "Minecraft lanseres offentlig", year: 2009, month: 5, day: 17, category: "Teknologi" },
      { event: "iPad lanseres", year: 2010, month: 4, day: 3, category: "Teknologi" },      
      { event: "OL i London", year: 2012, month: 7, day: 27, category: "Sport" },
      { event: "Edward Snowden lekker NSA-dokumenter", year: 2013, month: 6, day: 6, category: "Politikk" },
      { event: "PlayStation 4 lanseres", year: 2013, month: 11, day: 15, category: "Teknologi" },
      { event: "Nelson Mandela dør", year: 2013, month: 12, day: 5, category: "Politikk" },
      { event: "VM i fotball i Brasil", year: 2014, month: 6, day: 12, category: "Sport" },      
      { event: "Pokémon GO lanseres", year: 2016, month: 7, day: 6, category: "Teknologi" },
      { event: "Fidel Castro dør", year: 2016, month: 11, day: 25, category: "Politikk" },      
      { event: "Stephen Hawking dør", year: 2018, month: 3, day: 14, category: "Vitenskap" },       
      { event: "VM i fotball i Russland", year: 2018, month: 6, day: 14, category: "Sport" },
      { event: "Greta Thunberg taler i FN", year: 2019, month: 9, day: 23, category: "Klima" },    
      { event: "TikTok blir verdens mest nedlastede app", year: 2020, month: 8, day: 1, category: "Teknologi" },
      { event: "OL i Tokyo", year: 2021, month: 7, day: 23, category: "Sport" },
      { event: "Facebook endrer navn til Meta", year: 2021, month: 10, day: 28, category: "Teknologi" },
            { event: "Elon Musk kjøper Twitter", year: 2022, month: 10, day: 27, category: "Teknologi" },
      { event: "VM i fotball i Qatar", year: 2022, month: 11, day: 20, category: "Sport" },
          { event: "OL i Paris", year: 2024, month: 7, day: 26, category: "Sport" },
    ]
    },
    SPORT: {
    name: 'Sport',
    backgroundStyle: 'linear-gradient(to bottom, #dcfce7, #f0fdf4)',
    background: `
      <div class="sport-equipment">
        <div class="ball">⚽</div>
        <div class="ball">🏀</div>
        <div class="ball">🎾</div>
      </div>
      <div class="stadium-lines"></div>
    `,
    events: [
      { event: "Første moderne OL i Athen", year: 1896, category: "Sport" },
      { event: "Tour de France arrangeres første gang", year: 1903, category: "Sport" },
      { event: "Babe Ruth slår 60 homeruns på en sesong", year: 1927, category: "Sport" },
      { event: "Første VM i fotball", year: 1930, category: "Sport" },
      { event: "Jesse Owens vinner 4 gull i Berlin-OL", year: 1936, category: "Sport" },
      { event: "Jackie Robinson bryter farrebarrieren i baseball", year: 1947, category: "Sport" },
      { event: "Roger Bannister løper mila under 4 minutter", year: 1954, category: "Sport" },
      { event: "Pelé vinner sitt første VM (17 år)", year: 1958, category: "Sport" },
      { event: "Wilt Chamberlain scorer 100 poeng i én NBA-kamp", year: 1962, category: "Sport" },
      { event: "Muhammed Ali (Cassius Clay) vinner tungvektstittel", year: 1964, category: "Sport" },
      { event: "Nadia Comăneci får perfekt 10 i gymnastikk", year: 1976, category: "Sport" },
      { event: "Bjørn Borg vinner sin femte Wimbledon-tittel", year: 1980, category: "Sport" },
      { event: "Miracle on Ice - USA slår Sovjetunionen i ishockey", year: 1980, category: "Sport" },
      { event: "Maradona og 'Guds hånd'", year: 1986, category: "Sport" },
      { event: "Mike Tyson blir yngste tungvektsmester noensinne", year: 1986, category: "Sport" },
      { event: "Michael Jordan vinner sitt første NBA-mesterskap", year: 1991, category: "Sport" },
      { event: "Dream Team vinner OL-gull i basketball", year: 1992, category: "Sport" },
      { event: "OL i Lillehammer", year: 1994, category: "Norsk sport" },
      { event: "Johan Olav Koss vinner 3 gull i Lillehammer-OL", year: 1994, category: "Norsk sport" },
      { event: "Tiger Woods vinner Masters som 21-åring", year: 1997, category: "Sport" },
      { event: "Michael Schumacher vinner sitt første F1-mesterskap", year: 1994, category: "Sport" },
      { event: "Zinedine Zidane headbuttar Materazzi i VM-finalen", year: 2006, category: "Sport" },
      { event: "Usain Bolt setter verdensrekord på 100m (9,58)", year: 2009, category: "Sport" },
      { event: "Magnus Carlsen blir verdensmester i sjakk", year: 2013, category: "Norsk sport" },
      { event: "Ole Einar Bjørndalen blir tidenes mestvinnende vinterolympier", year: 2014, category: "Norsk sport" },
      { event: "Leicester City vinner Premier League (5000-1 odds)", year: 2016, category: "Sport" },
      { event: "Martin Ødegaard blir Real Madrids yngste spiller", year: 2015, category: "Norsk sport" },
      { event: "Tiger Woods vinner Masters etter comeback", year: 2019, category: "Sport" },
      { event: "Liverpool vinner Champions League etter mirakelet på Anfield", "year": 2019, "category": "Sport" },
      { event: "Diego Maradona dør", year: 2020, category: "Sport" },
      { event: "Therese Johaug vinner OL-gull etter utestengelse", year: 2022, category: "Norsk sport" },
      { event: "Karsten Warholm setter verdensrekord på 400m hekk", year: 2021, category: "Norsk sport" },
      { event: "Lionel Messi vinner VM med Argentina", year: 2022, category: "Sport" },
      { event: "Erling Braut Haaland scorer 9 mål i en U20-kamp", year: 2019, category: "Norsk sport" },
      { event: "Første Super Bowl spilles", year: 1967, category: "Sport" },
      { event: "Muhammad Ali nekter å gå i Vietnam-krigen", year: 1967, category: "Sport" },
    ]
  },
   MUSIKK: {
    name: 'Musikk',
    backgroundStyle: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    background: `
      <div class="musical-notes">
        <div class="note">♪</div>
        <div class="note">♫</div>
        <div class="note">♪</div>
        <div class="note">♫</div>
      </div>
      <div class="vinyl-disc"></div>
      <div class="vinyl-disc"></div>
    `,
    events: [
      { event: "Mozart blir født", year: 1756, category: "Klassisk" },
      { event: "Beethoven blir født", year: 1770, category: "Klassisk" },
      { event: "Edvard Grieg blir født", year: 1843, category: "Norsk musikk" },      
      { event: "Louis Armstrong gjør sitt første opptak", year: 1923, category: "Jazz" },
      { event: "Elvis Presley blir født", year: 1935, category: "Rock" },
      { event: "Chuck Berry 'Johnny B. Goode'", year: 1958, category: "Rock" },
      { event: "The Beatles dannes", year: 1960, category: "Rock" },
      { event: "Bob Dylan fremfører 'Blowin' in the Wind' første gang", year: 1962, category: "Folk" },
      { event: "The Rolling Stones dannes", year: 1962, category: "Rock" },
      { event: "The Beatles 'Sgt. Pepper's'", year: 1967, category: "Rock" },
      { event: "Jimi Hendrix 'Purple Haze'", year: 1967, category: "Rock" },
      { event: "Woodstock-festivalen", year: 1969, category: "Rock" },
      { event: "The Beatles splittes", year: 1970, category: "Rock" },
      { event: "Lillebjørn Nilsen 'Tanta til Beate'", year: 1982, category: "Norsk musikk" },
      { event: "Led Zeppelin 'Stairway to Heaven'", year: 1971, category: "Rock" },
      { event: "ABBA vinner Eurovision med 'Waterloo'", year: 1974, category: "Pop" },
      { event: "Queen 'Bohemian Rhapsody'", year: 1975, category: "Rock" },
      { event: "Sex Pistols 'Anarchy in the UK'", year: 1976, category: "Punk" },
      { event: "Elvis Presley dør", year: 1977, category: "Rock" },
      { event: "Michael Jackson 'Thriller'", year: 1982, category: "Pop" },
      { event: "MTV lanseres", year: 1981, category: "Musikk" },
      { event: "Madonna 'Like a Virgin'", year: 1984, category: "Pop" },
      { event: "Live Aid-konserten", year: 1985, category: "Musikk" },
      { event: "a-ha 'Take On Me'", year: 1985, category: "Norsk musikk" },
      { event: "N.W.A. 'Straight Outta Compton'", year: 1988, category: "Hip-hop" },
      { event: "Nirvana 'Nevermind'", year: 1991, category: "Grunge" },
      { event: "Kurt Cobain dør", year: 1994, category: "Rock" },
      { event: "Oasis 'Wonderwall'", year: 1995, category: "Rock" },
      { event: "Spice Girls 'Wannabe'", year: 1996, category: "Pop" },
      { event: "Napster lanseres", year: 1999, category: "Teknologi" },
      { event: "Kaizers Orchestra dannes", year: 2000, category: "Norsk musikk" },
      { event: "iPod lanseres", year: 2001, category: "Teknologi" },
      { event: "Amy Winehouse 'Back to Black'", year: 2006, category: "Soul" },
      { event: "Spotify lanseres", year: 2008, category: "Teknologi" },
      { event: "Michael Jackson dør", year: 2009, category: "Pop" },
      { event: "Adele '21'", year: 2011, category: "Pop" },
      { event: "Whitney Houston dør", year: 2012, category: "Pop" },
      { event: "Kygo gjennombrudd med 'Firestone'", year: 2014, category: "Norsk musikk" },
      { event: "Beyoncé 'Lemonade'", year: 2016, category: "Pop" },
      { event: "David Bowie dør", year: 2016, category: "Rock" },
      { event: "Avicii dør", year: 2018, category: "EDM" },
      { event: "Billie Eilish vinner 5 Grammy", year: 2020, category: "Pop" },
      { event: "Taylor Swift 'Folklore'", year: 2020, category: "Pop" },      
      { event: "The Weeknd 'Blinding Lights'", year: 2020, category: "Pop" },     
      { event: "Ed Sheeran 'Shape of You'", year: 2017, category: "Pop" },
      { event: "Drake 'Hotline Bling'", year: 2015, category: "Hip-hop" },
      { event: "Kanye West 'Gold Digger'", year: 2005, category: "Hip-hop" },
      { event: "Eminem 'Lose Yourself'", year: 2002, category: "Hip-hop" },      
    ]
  },
  VITENSKAP: {
    name: 'Naturvitenskap',
  backgroundStyle: 'linear-gradient(to bottom, #eef2ff, #e0e7ff)',
  background: `
    <div class="science-atoms">
      <div class="atom">⚛</div>
      <div class="atom">⚛</div>
    </div>
    <div class="science-formula">E=mc²</div>
    <div class="dna-helix"></div>
  `,
    events: [
      { event: "Galileo Galilei oppdager Jupiters måner", year: 1610, category: "Astronomi" },
      { event: "Isaac Newton publiserer 'Principia'", year: 1687, category: "Fysikk" },
      { event: "Benjamin Franklin oppdager at lynet er elektrisitet", year: 1752, category: "Fysikk" },
      { event: "Første dampmaskin", year: 1769, category: "Teknologi" },
      { event: "Første vaksine (kukopper)", year: 1796, category: "Medisin" },
      { event: "Første batteri oppfinnes", year: 1800, category: "Fysikk" },
      { event: "Charles Darwin publiserer evolusjonsteorien", year: 1859, category: "Biologi" },
      { event: "Mendeleev lager periodesystemet", year: 1869, category: "Kjemi" },
      { event: "Telefonen blir oppfunnet", year: 1876, category: "Teknologi" },
      { event: "Lyspæren blir oppfunnet", year: 1879, category: "Teknologi" },
      { event: "Røntgenstråler oppdages", year: 1895, category: "Fysikk" },
      { event: "Radium oppdages av Marie Curie", year: 1898, category: "Kjemi" },
      { event: "Wright-brødrene flyr første motoriserte fly", year: 1903, category: "Teknologi" },
      { event: "Einsteins relativitetsteori (E=mc2)", year: 1905, category: "Fysikk" },
      { event: "Alexander Fleming oppdager penicillin", year: 1928, category: "Medisin" },
      { event: "Pluto oppdages", year: 1930, category: "Astronomi" },
      { event: "Første atomspaltning", year: 1938, category: "Fysikk" },
      { event: "Første datamaskin (ENIAC)", year: 1946, category: "Teknologi" },
      { event: "Transistoren oppfinnes", year: 1947, category: "Teknologi" },
      { event: "DNA-strukturen oppdages", year: 1953, category: "Biologi" },
      { event: "Første satellitt (Sputnik) sendes opp", year: 1957, category: "Romfart" },
      { event: "Første menneske i rommet (Gagarin)", year: 1961, category: "Romfart" },
      { event: "Første menneske på månen (Apollo 11)", year: 1969, category: "Romfart" },
      { event: "Første hjerte-transplantasjon", year: 1967, category: "Medisin" },      
      { event: "Første e-post sendes", year: 1971, category: "Teknologi" },
      { event: "MRI-scanneren oppfinnes", year: 1977, category: "Medisin" },
      { event: "Første prøverørsbaby fødes", year: 1978, category: "Medisin" },
      { event: "HIV-viruset identifiseres", year: 1983, category: "Medisin" },
      { event: "Ozonhullet oppdages", year: 1985, category: "Miljø" },
      { event: "Tsjernobyl-ulykken", year: 1986, category: "Miljø" },
      { event: "World Wide Web oppfinnes", year: 1989, category: "Teknologi" },
      { event: "Hubble-teleskopet sendes opp", year: 1990, category: "Romfart" },
      { event: "Første nettleser lanseres", year: 1993, category: "Teknologi" },
      { event: "Sauen Dolly klones", year: 1996, category: "Biologi" },      
      { event: "Facebook lanseres", year: 2004, category: "Teknologi" },
      { event: "iPhone lanseres", year: 2007, category: "Teknologi" },
      { event: "Higgs-partikkelen oppdages", year: 2012, category: "Fysikk" },       
      { event: "Første bilde av svart hull", year: 2019, category: "Astronomi" },
      { event: "COVID-19 vaksiner utvikles på rekordtid", year: 2020, category: "Medisin" },
      { event: "James Webb-teleskopet sendes opp", year: 2021, category: "Romfart" },      
      { event: "AI-modellen GPT-3 lanseres", year: 2020, category: "Teknologi" },      
      { event: "Første vellykkede organtransplantasjon fra gris til menneske", year: 2022, category: "Medisin" },
    ]
  },
BARN: {
    name: 'For barn (6-12 år)',
    backgroundStyle: 'linear-gradient(to top, #a2d2ff, #cdb4db)', // Mer leken gradient
    background: `
      <div class="bubble-wrapper">
        <div class="bubble"></div><div class="bubble"></div><div class="bubble"></div>
        <div class="bubble"></div><div class="bubble"></div><div class="bubble"></div>
        <div class="bubble"></div><div class="bubble"></div><div class="bubble"></div>
        <div class="bubble"></div>
      </div>
    `,
    events: [
      { event: "Dinosaurene dør ut", year: -65000000, category: "Forhistorie" },
      { event: "Pyramidene i Egypt bygges", year: -2500, category: "Oldtiden" },
      { event: "Jesus blir født", year: 0, category: "Historie" },
      { event: "Vikingtiden begynner", year: 793, category: "Historie" },
      { event: "Columbus reiser til Amerika", year: 1492, category: "Oppdagelser" },
      { event: "Boktrykkerkunsten oppfinnes", year: 1440, category: "Oppfinnelser" },
      { event: "Første avis lages", year: 1605, category: "Kommunikasjon" },
      { event: "Første jernbane", year: 1825, category: "Transport" },
      { event: "Telefonen oppfinnes", year: 1876, category: "Oppfinnelser" },
      { event: "Lyspæren oppfinnes", year: 1879, category: "Oppfinnelser" },
      { event: "Første bil lages", year: 1886, category: "Transport" },
      { event: "Første kino åpner", year: 1895, category: "Underholdning" },
      { event: "Første fly", year: 1903, category: "Transport" },
      { event: "Titanic synker", year: 1912, category: "Historie" },
      { event: "Første verdenskrig", year: 1914, category: "Historie" },
      { event: "Mickey Mouse blir til", year: 1928, category: "Tegnefilm" },
      { event: "LEGO-klossen finnes opp", year: 1958, category: "Leker" },
      { event: "Donald Duck blir til", year: 1934, category: "Tegnefilm" },
      { event: "Andre verdenskrig", year: 1939, category: "Historie" },
      { event: "Første datamaskin", year: 1946, category: "Teknologi" },
      { event: "Første TV-sending i Norge", year: 1960, category: "TV" },
      { event: "Første menneske på månen", year: 1969, category: "Romfart" },      
      { event: "Super Mario blir til", year: 1985, category: "Spill" },
      { event: "Internett blir tilgjengelig for alle", year: 1991, category: "Teknologi" },
      { event: "Løvenes konge kommer på kino", year: 1994, category: "Film" },
      { event: "Toy Story kommer på kino", year: 1995, category: "Film" },
      { event: "Pokémon lages", year: 1996, category: "Spill" },
      { event: "Harry Potter første bok", year: 1997, category: "Bøker" },
      { event: "Google startes", year: 1998, category: "Internett" },
      { event: "Wikipedia lages", year: 2001, category: "Internett" },          
      { event: "YouTube startes", year: 2005, category: "Internett" },      
      { event: "Minecraft lages", year: 2009, category: "Spill" },     
      { event: "Frozen kommer på kino", year: 2013, category: "Film" },
      { event: "Fortnite lages", year: 2017, category: "Spill" },
      { event: "TikTok blir populært", year: 2018, category: "Internett" },      
      { event: "Corona-pandemien begynner", year: 2020, category: "Historie" },     
      { event: "Roblox blir til", year: 2006, category: "Spill" },
      { event: "ChatGPT lages (robot som kan snakke)", year: 2022, category: "Teknologi" },
      { event: "Barbie-filmen på kino", year: 2023, category: "Film" },
      { event: "Minecraft-filmen på kino", year: 2025, category: "Film" },
    ]
  }
  };


const formatDateForCard = (card) => {
  if (!card) return '';
  const year = card.year;
  const month = card.month;
  const day = card.day;

  const monthNames = ["", "Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"];

  let dateString = '';
  if (day && month) {
    dateString += `${day}. `;
  }
  if (month) {
    dateString += `${monthNames[month]} `;
  }

  if (year < 0) {
    dateString += `${Math.abs(year)} fvt.`;
  } else {
    dateString += year;
  }
  return dateString;
};

const getCategoryColor = (category) => {
  return '#334155';
};

const EventCard = ({ card, isPlaceholder, onClick, isCurrent, feedback }) => {
  if (isPlaceholder) {
    return (
      <button onClick={onClick} style={{
        minWidth: '70px',
        height: '110px',
        border: '3px dashed #cbd5e1',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '28px',
        color: '#94a3b8',
        backgroundColor: 'white',
        transition: 'all 0.2s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#f8fafc';
        e.currentTarget.style.borderColor = '#64748b';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'white';
        e.currentTarget.style.borderColor = '#cbd5e1';
      }}>
        ↓
      </button>
    );
  }

  return (
    <div style={{
      minWidth: '120px',
      maxWidth: '120px',
      height: '110px',
      backgroundColor: getCategoryColor(card.category),
      color: 'white',
      padding: '12px',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      border: isCurrent ? '3px solid #3b82f6' : 'none',
      transform: isCurrent ? 'scale(1.05)' : 'scale(1)',
      transition: 'all 0.2s',
      flexShrink: 0,
      // ENDRING 5: Visuell feedback for feil/riktig svar
      outlineOffset: '2px',
      outline: feedback === 'correct' ? '4px solid #10b981' : feedback === 'incorrect' ? '4px solid #ef4444' : 'none',
    }}>
      <div style={{
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '1.3',
        flex: 1,
        display: 'flex',
        alignItems: 'center'
      }}>
        {card.event}
      </div>
      <div style={{
        fontSize: '16px',
        fontWeight: '700',
        borderTop: '1px solid rgba(255,255,255,0.3)',
        paddingTop: '6px'
      }}>
        {formatDateForCard(card)}
      </div>
    </div>
  );
};

const PlayerSetup = ({ gameMode, setGameMode, playerConfigs, setPlayerConfigs, onStart, selectedPack, setSelectedPack, gameSettings, setGameSettings }) => {
  const [openColorPicker, setOpenColorPicker] = useState(null); 
  const [openAvatarPicker, setOpenAvatarPicker] = useState(null);

   const updatePlayerCount = (count) => {
    const newConfigs = Array.from({ length: count }, (_, i) =>
      playerConfigs[i] || { name: '', color: i % PLAYER_COLORS.length, avatar: i % PLAYER_AVATARS.length }
    );
    setPlayerConfigs(newConfigs);
  };
  
  const updatePlayerConfig = (index, field, value) => {
    const newConfigs = [...playerConfigs];
    newConfigs[index] = { ...newConfigs[index], [field]: value };
    setPlayerConfigs(newConfigs);
  };

  const modeDescriptions = {
    single: 'Øv alene. Hvor mange kort klarer du å plassere riktig på rad?',
    risk: 'Hver spiller bygger sin egen tidslinje. Trekk kort til du vil stoppe (maks 10). Feil = mister alle kort i runden.',
    duel: 'Felles tidslinje. 1 kort per tur. Riktig = +1 poeng. Feil = motspillerne får +1 poeng hver og kortet går tilbake.',
    knockout: 'Felles tidslinje. Ett feil = du er permanent ute. Siste spiller igjen vinner!',
    gamble: 'Egen tidslinje. Satse 1-3 chips eller fold. Riktig = dobbelt tilbake. Feil = mist chips. Første til målet vinner!'
  };

  return (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(to bottom right, #e0e7ff, #f9fafb)',
    display: 'flex',
    alignItems: 'flex-start', // Holder toppen fast
    justifyContent: 'center',
    padding: '20px',
    paddingTop: '80px', // 👈 Øk denne for mer luft på toppen
    paddingBottom: '80px', // 👈 Legg til bottom padding
    position: 'relative',
    overflow: 'auto' // 👈 Endre fra 'hidden' til 'auto' for scrolling
  }}>
      {/* Bakgrunnselementene som ligger bakerst */}
      <div className="setup-background">
        <div className="setup-icon hourglass">⏳</div>
        <div className="setup-icon compass">🧭</div>
        <div className="setup-icon clock">🕰️</div>
        <div className="setup-icon scroll">📜</div>
        <div className="setup-icon globe">🌍</div>
      </div>

      {/* Den hvite boksen som ligger oppå bakgrunnen */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        padding: '32px',
        maxWidth: '700px',
        width: '100%',
        position: 'relative', // Endret fra zIndex: 1 for enklere lagdeling
        zIndex: 1,
        minHeight: '650px' 
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#1e293b', margin: '0 0 8px 0' }}>
            Alle tiders tidslinje
          </h1>
          <p style={{ color: '#64748b', fontSize: '15px', margin: '0' }}>
            Plasser historiske hendelser i rett rekkefølge
          </p>
        </div>

{/* NY SEKSJON FOR KATEGORIVELGER */}
<div style={{ marginBottom: '32px' }}>
  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '12px' }}>
    Velg hendelsespakke
  </label>
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '8px' }}>
    {Object.keys(EVENT_PACKS).map((packKey) => {
      const packColors = {
        ALLMENN_HISTORIE: { bg: '#f3f1e9', border: '#d4cfc0', text: '#5a5244' },
        WW2: { bg: '#e5e7eb', border: '#9ca3af', text: '#374151' },
        COLD_WAR: { bg: '#fecaca', border: '#ef4444', text: '#7f1d1d' },
        POST_2000: { bg: '#1e293b', border: '#0f172a', text: '#e2e8f0' },
        SPORT: { bg: '#dcfce7', border: '#16a34a', text: '#14532d' },
        MUSIKK: { bg: '#1e1b4b', border: '#4338ca', text: '#e0e7ff' },
        VITENSKAP: { bg: '#e0e7ff', border: '#6366f1', text: '#312e81' },
        BARN: { bg: '#fae8ff', border: '#d946ef', text: '#701a75' }
      };
      const colors = packColors[packKey] || { bg: 'white', border: '#e2e8f0', text: '#64748b' };
      const isSelected = selectedPack === packKey;
      
      return (
        <button
          key={packKey}
          onClick={() => setSelectedPack(packKey)}
          style={{
            padding: '12px',
            borderRadius: '8px',
            border: isSelected ? `2px solid ${colors.border}` : '2px solid #e2e8f0',
            backgroundColor: isSelected ? colors.bg : 'white',
            cursor: 'pointer',
            transition: 'all 0.2s',
            fontSize: '14px',
            fontWeight: '600',
            color: isSelected ? colors.text : '#64748b',
            opacity: isSelected ? 1 : 0.7
          }}
          onMouseEnter={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = colors.bg;
              e.currentTarget.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.opacity = '0.7';
            }
          }}
        >
          {EVENT_PACKS[packKey].name}
        </button>
      );
    })}
  </div>
</div>

 <div style={{ marginBottom: '24px' }}>
  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '12px' }}>
    Spillmodus
  </label>
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '8px' }}>
    {[
      { mode: 'single', icon: User, title: 'Spill alene', bg: '#dbeafe', border: '#3b82f6', text: '#1e40af' },
      { mode: 'risk', icon: Target, title: 'Risiko', bg: '#fef3c7', border: '#f59e0b', text: '#92400e' },
      { mode: 'duel', icon: Trophy, title: 'Duell', bg: '#fce7f3', border: '#ec4899', text: '#831843' },
      { mode: 'knockout', icon: Skull, title: 'Knockout', bg: '#fee2e2', border: '#ef4444', text: '#7f1d1d' },
      { mode: 'gamble', icon: Trophy, title: 'Gamble', bg: '#dcfce7', border: '#10b981', text: '#14532d' }
    ].map(({ mode, icon: Icon, title, bg, border, text }) => {
      const isSelected = gameMode === mode;
      
      return (
        <button
          key={mode}
          onClick={() => setGameMode(mode)}
          style={{
            padding: '12px',
            borderRadius: '8px',
            border: isSelected ? `2px solid ${border}` : '2px solid #e2e8f0',
            backgroundColor: isSelected ? bg : 'white',
            cursor: 'pointer',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: isSelected ? text : '#64748b',
            opacity: isSelected ? 1 : 0.7
          }}
          onMouseEnter={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = bg;
              e.currentTarget.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.opacity = '0.7';
            }
          }}
        >
          <Icon size={16} />
          {title}
        </button>
      );
    })}
  </div>
  <div style={{
    marginTop: '12px',
    padding: '12px',
    backgroundColor: '#f8fafc',
    borderRadius: '6px',
    fontSize: '13px',
    color: '#475569',
    lineHeight: '1.5'
  }}>
    {modeDescriptions[gameMode]}
  </div>
</div>



     {gameMode !== 'single' && (
  <>
   {gameMode === 'gamble' && (
       <div style={{ marginBottom: '20px' }}>
         <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '8px' }}>
           Spill til
         </label>
         <select
           value={gameSettings.targetChips}
           onChange={(e) => setGameSettings({ ...gameSettings, targetChips: Number(e.target.value) })}
           style={{
             width: '100%', padding: '10px', border: '2px solid #e2e8f0',
             borderRadius: '8px', fontSize: '14px', outline: 'none', backgroundColor: 'white'
           }}
         >
           <option value={35}>35 chips</option>
           <option value={50}>50 chips</option>
           <option value={75}>75 chips</option>
         </select>
       </div>
     )}

<div style={{ marginBottom: '20px' }}>
      <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '8px' }}>
        Antall spillere
      </label>
      <select
        value={playerConfigs.length}
        onChange={(e) => updatePlayerCount(Number(e.target.value))}
        style={{
          width: '100%', padding: '10px', border: '2px solid #e2e8f0',
          borderRadius: '8px', fontSize: '14px', outline: 'none', backgroundColor: 'white'
        }}
      >
        {[2, 3, 4, 5, 6].map(n => <option key={n} value={n}>{n} spillere</option>)}
      </select>
    </div>


    <div style={{ marginBottom: '20px' }}>
      <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '8px' }}>
        Spillere
      </label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        
        {playerConfigs.map((config, i) => (
          <div key={i} style={{
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            padding: '12px',
            display: 'grid',
            gridTemplateColumns: '2fr auto 40px',
            gap: '12px',
            alignItems: 'center'
          }}>

            {/* Kolonne 1: Navn-input */}
            <input
              type="text"
              placeholder={`Spiller ${i + 1}`}
              value={config.name}
              onChange={(e) => updatePlayerConfig(i, 'name', e.target.value)}
              style={{
                padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px',
                fontSize: '14px', outline: 'none'
              }}
            />

            {/* Kolonne 2: Wrapper for farge- og avatar-velger */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'flex-start' }}>
              
              {/* Fargevelger */}
              <div style={{ position: 'relative', height: '40px', display: 'flex', alignItems: 'center' }}>
                <button
                  type="button"
                  onClick={() => setOpenColorPicker(openColorPicker === i ? null : i)}
                  style={{
                    width: '28px', height: '28px', borderRadius: '50%',
                    backgroundColor: PLAYER_COLORS[config.color],
                    border: '2px solid rgba(0, 0, 0, 0.1)', cursor: 'pointer',
                  }}
                />
                {openColorPicker === i && (
                  <div style={{
                    position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)',
                    marginTop: '8px', padding: '8px', backgroundColor: 'white', borderRadius: '12px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.15)', display: 'flex', gap: '6px', zIndex: 10,
                  }}>
                    {PLAYER_COLORS.map((color, idx) => (
                      <button
                        key={idx} type="button" onClick={() => { updatePlayerConfig(i, 'color', idx); setOpenColorPicker(null); }}
                        style={{
                          width: '24px', height: '24px', borderRadius: '50%', backgroundColor: color,
                          border: 'none', cursor: 'pointer', transition: 'transform 0.1s ease',
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* Avatar-velger */}
              <div style={{ position: 'relative', height: '40px', display: 'flex', alignItems: 'center' }}>
                <button
                  type="button"
                  onClick={() => setOpenAvatarPicker(openAvatarPicker === i ? null : i)}
                  style={{
                    width: '36px', height: '36px', borderRadius: '8px', border: '1px solid #e2e8f0',
                    backgroundColor: 'white', cursor: 'pointer', fontSize: '20px', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  {PLAYER_AVATARS[config.avatar]}
                </button>
                {openAvatarPicker === i && (
                  <div style={{
                    position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)',
                    marginTop: '8px', padding: '8px', backgroundColor: 'white', borderRadius: '12px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.15)', display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)', gap: '6px', zIndex: 10,
                  }}>
                    {PLAYER_AVATARS.map((avatar, idx) => (
                      <button
                        key={idx} type="button" onClick={() => { updatePlayerConfig(i, 'avatar', idx); setOpenAvatarPicker(null); }}
                        style={{
                          width: '36px', height: '36px', borderRadius: '8px', border: 'none',
                          backgroundColor: idx === config.avatar ? '#eff6ff' : 'transparent',
                          cursor: 'pointer', fontSize: '20px', display: 'flex', alignItems: 'center',
                          justifyContent: 'center', transition: 'background-color 0.2s ease',
                        }}
                      >
                        {avatar}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
    
{/* Kolonne 3: Forhåndsvisning */}
            <div style={{
              width: '40px', height: '40px', borderRadius: '50%', display: 'flex',
              alignItems: 'center', justifyContent: 'center', color: 'white',
              fontSize: '20px', backgroundColor: PLAYER_COLORS[config.color],
              border: '2px solid rgba(0,0,0,0.1)', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              {PLAYER_AVATARS[config.avatar]}
            </div>

          </div>
        ))}
      </div>
    </div>
  </>
)}

<button
  onClick={onStart}
  style={{
    width: '100%',
    backgroundColor: '#3b82f6',
    color: 'white',
    padding: '14px',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '15px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  }}
>
  <Play size={18} />
  Start spill
</button>
</div>
</div>
);
};


const GlobalStyle = createGlobalStyle`
  /* SCROLLBAR-STILER */
  .timeline-scroll-container::-webkit-scrollbar { height: 18px; }
  .timeline-scroll-container::-webkit-scrollbar-track { background: #e2e8f0; border-radius: 10px; }
  .timeline-scroll-container::-webkit-scrollbar-thumb { background-color: #475569; border-radius: 10px; border: 5px solid #e2e8f0; }
  .timeline-scroll-container { scrollbar-width: auto; scrollbar-color: #475569 #e2e8f0; }

  /* BAKGRUNN FOR STARTSKJEM */
  .setup-background {
    position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;
  }
  .setup-icon {
    position: absolute;
    opacity: 0;
    animation: drift 15s ease-in-out infinite alternate, 
               float 8s ease-in-out infinite,
               fadeInOut 18s ease-in-out infinite;
  }

  .setup-icon.hourglass { 
    font-size: 8vw; 
    top: 70%; 
    left: 10%; 
    animation-duration: 30s, 10s, 12s;
    animation-delay: 1s, 3, 5s;
  }

  .setup-icon.compass { 
    font-size: 12vw; 
    top: 10%; 
    right: 6%; 
    animation-duration: 25s, 5s, 14s;
    animation-delay: 2s, 1s, 3s;
  }

  .setup-icon.clock { 
    font-size: 9vw; 
    top: 50%; 
    right: 15%; 
    animation-duration: 35s, 9s, 23s;
    animation-delay: 4s, 4s, 7s;
  }

  .setup-icon.scroll { 
    font-size: 7vw; 
    top: 10%; 
    right: 75%; 
    animation-duration: 28s, 11s, 19s;
    animation-delay: 1s, 5s, 9s;
  }

  .setup-icon.globe { 
    font-size: 10vw; 
    top: 28%; 
    left: 4%; 
    animation-duration: 22s, 8s, 21s;
    animation-delay: 3s, 2s, 2s;
  }

  /* GENERELL BAKGRUNNS-CONTAINER FOR SPILLET */
  .category-background {
    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
    z-index: 0; pointer-events: none; overflow: hidden;
  }

  /* ALLMENN HISTORIE */
  .map-lines {
    width: 100%; height: 100%; opacity: 0.05;
    background: repeating-linear-gradient(0deg, #999 0, #999 1px, transparent 1px, transparent 100px),
                repeating-linear-gradient(90deg, #999 0, #999 1px, transparent 1px, transparent 100px);
  }
  .compass-rose {
    position: absolute; top: 15%; right: 15%; font-size: 150px; opacity: 0.08;
    animation: slowRotate 80s linear infinite;
  }
  .history-hourglass {  // 👈 Nytt navn
  position: absolute; bottom: 10%; left: 15%; font-size: 120px; opacity: 0.15;
  animation: wobble 10s ease-in-out infinite;
}

  /* WW2 */
  .ww2-planes .plane {
    position: absolute; font-size: 60px; opacity: 0;
    animation: flyAcross 25s linear infinite;
  }
  .ww2-planes .plane:nth-child(1) { top: 20%; animation-delay: 0s; }
  .ww2-planes .plane:nth-child(2) {
    top: 70%; animation-delay: 5s;
    animation-name: flyAcrossReverse;
    transform: scaleX(-1);
  }
  .ww2-grid { display: none; }

  /* KALD KRIG */
  .cold-war-symbols .star {
    position: absolute;
    font-size: 120px;
    opacity: 0.05;
    animation: tensePulse 7s ease-in-out infinite alternate;
  }
  .cold-war-symbols .star:nth-child(1) { top: 15%; left: 6%; color: #d1d5db; }
  .cold-war-symbols .star:nth-child(2) { top: 65%; right: 10%; color: #fef08a; animation-delay: 1.5s; }
  .cold-war-symbols .star:nth-child(3) { top: 75%; right: 80%; color: #fef08a; animation-delay: 3.5s; font-family: serif; }

  /* ETTER 2000 */
  .binary-rain span {
    position: absolute; font-family: monospace; font-size: 2vh; color: #34d3997e;
    opacity: 0; animation: rainFall 15s linear infinite;
  }
  .binary-rain span:nth-child(odd) { animation-duration: 10s; }
  .binary-rain span:nth-child(even) { animation-duration: 15s; }
  .binary-rain span:nth-child(1) { left: 5%; animation-delay: 0s; }
  .binary-rain span:nth-child(2) { left: 15%; animation-delay: 2s; }
  .binary-rain span:nth-child(3) { left: 25%; animation-delay: 4s; }
  .binary-rain span:nth-child(4) { left: 35%; animation-delay: 1s; }
  .binary-rain span:nth-child(5) { left: 45%; animation-delay: 6s; }
  .binary-rain span:nth-child(6) { left: 55%; animation-delay: 8s; }
  .binary-rain span:nth-child(7) { left: 65%; animation-delay: 5s; }
  .binary-rain span:nth-child(8) { left: 75%; animation-delay: 10s; }
  .binary-rain span:nth-child(9) { left: 85%; animation-delay: 7s; }
  .binary-rain span:nth-child(10) { left: 95%; animation-delay: 12s; }

  /* SPORT */
  .sport-equipment .ball {
    position: absolute; font-size: 70px; opacity: 0.06;
    animation: bounce 6s ease-in-out infinite;
  }
  .sport-equipment .ball:nth-child(1) { top: 15%; left: 8%; animation-delay: 0s; }
  .sport-equipment .ball:nth-child(2) { top: 60%; right: 20%; animation-delay: 2s; }
  .sport-equipment .ball:nth-child(3) { bottom: 20%; left: 60%; animation-delay: 4s; }
  .stadium-lines {
    position: absolute; width: 100%; height: 100%;
    background: repeating-linear-gradient(0deg, transparent 0 80px, rgba(34, 197, 94, 0.03) 80px 82px);
  }

  /* MUSIKK */
  .note {
    position: absolute; font-size: 80px; animation: float 8s infinite ease-in-out;
    color: #000; opacity: 0.1;
  }
  .note:nth-child(1) { left: 8%; top: 20%; animation-delay: 0s; }
  .note:nth-child(2) { left: 75%; top: 15%; animation-delay: 2s; }
  .note:nth-child(3) { left: 25%; top: 70%; animation-delay: 4s; }
  .note:nth-child(4) { left: 85%; top: 75%; animation-delay: 6s; }
  .vinyl-disc {
    position: absolute; width: 180px; height: 180px; border-radius: 50%;
    background: radial-gradient(circle, transparent 15%, rgba(0,0,0, 0.03) 15% 20%, transparent 20%);
    opacity: 0.12;
  }

  /* NATURVITENSKAP */
  .science-atoms .atom {
    position: absolute; font-size: 100px; opacity: 0.05;
    animation: rotate 20s linear infinite;
  }
  .science-atoms .atom:nth-child(1) { top: 20%; left: 5%; }
  .science-atoms .atom:nth-child(2) { bottom: 20%; right: 15%; animation-direction: reverse; }
  .science-formula, .dna-helix { opacity: 0.06; }

  /* BARN */
  .bubble {
    position: absolute; bottom: -150px; border-radius: 50%;
    animation: rise 25s infinite; opacity: 0;
  }
  .bubble:nth-child(1) { width: 80px; height: 80px; left: 10%; background: #ffafcc; animation-duration: 22s; animation-delay: 0s; }
  .bubble:nth-child(2) { width: 40px; height: 40px; left: 20%; background: #a2d2ff; animation-duration: 18s; animation-delay: 3s; }
  .bubble:nth-child(3) { width: 100px; height: 100px; left: 35%; background: #bde0fe; animation-duration: 25s; animation-delay: 6s; }
  .bubble:nth-child(4) { width: 50px; height: 50px; left: 50%; background: #ffc8dd; animation-duration: 16s; animation-delay: 9s; }
  .bubble:nth-child(5) { width: 120px; height: 120px; left: 65%; background: #cdb4db; animation-duration: 28s; animation-delay: 12s; }
  .bubble:nth-child(6) { width: 60px; height: 60px; left: 80%; background: #a2d2ff; animation-duration: 20s; animation-delay: 15s; }
  .bubble:nth-child(7) { width: 30px; height: 30px; left: 90%; background: #ffafcc; animation-duration: 15s; animation-delay: 18s; }
  .bubble:nth-child(8) { width: 90px; height: 90px; left: 5%; background: #bde0fe; animation-duration: 26s; animation-delay: 21s; }

  /* ======= ALLE KEYFRAMES SAMLET ======= */
  @keyframes drift { from { transform: translateY(-20px) rotate(-10deg); } to { transform: translateY(20px) rotate(10deg); } }
  @keyframes slowRotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  @keyframes wobble { 0%, 100% { transform: rotate(-2deg); } 50% { transform: rotate(2deg); } }
  @keyframes flyAcross {
    0% { transform: translateX(-200px); opacity: 0; } 5% { opacity: 0.05; }
    95% { opacity: 0.05; } 100% { transform: translateX(calc(100vw + 200px)); opacity: 0; }
  }
  @keyframes flyAcrossReverse {
    0% { transform: translateX(calc(100vw + 200px)) scaleX(-1); opacity: 0; } 5% { opacity: 0.05; }
    95% { opacity: 0.05; } 100% { transform: translateX(-200px) scaleX(-1); opacity: 0; }
  }
  @keyframes tensePulse {
    from { opacity: 0.08; } to { opacity: 0.12; }
  }
  @keyframes rainFall {
    0% { transform: translateY(-10vh); opacity: 0; } 5% { opacity: 0.4; }
    95% { opacity: 0.4; } 100% { transform: translateY(110vh); opacity: 0; }
  }
  @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-45px); } }
  @keyframes float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-30px); } }
  @keyframes rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  @keyframes rise {
    0% { transform: translateY(0); opacity: 0; } 10% { opacity: 0.2; }
    90% { opacity: 0.2; } 100% { transform: translateY(-120vh); opacity: 0; }
  }
  @keyframes fadeInOut {
    0% { opacity: 0; }
    15% { opacity: 0.15; }
    85% { opacity: 0.15; }
    100% { opacity: 0; }
  }
`;

const TimelineGame = () => {
  const [gameState, setGameState] = useState('setup');  
  const [isSafePlay, setIsSafePlay] = useState(false);
  const [selectedPack, setSelectedPack] = useState('ALLMENN_HISTORIE'); 
  const [gameMode, setGameMode] = useState('risk');
  const [players, setPlayers] = useState([]);
  const [currentPlayerIndex, setCurrentPlayerIndex] = useState(0);
  const [scores, setScores] = useState([]);
  const [roundScores, setRoundScores] = useState([]);
  const [timeline, setTimeline] = useState([]);
  const [timelines, setTimelines] = useState([]);
  const [availableCards, setAvailableCards] = useState([]);
  const [currentCard, setCurrentCard] = useState(null);
  const [gameMessage, setGameMessage] = useState('');
  const [showCardInfo, setShowCardInfo] = useState(false);
  const [eliminatedPlayers, setEliminatedPlayers] = useState([]);
  const [roundNumber, setRoundNumber] = useState(1);
const [playerConfigs, setPlayerConfigs] = useState([
    { name: '', color: 0, avatar: 0 },
    { name: '', color: 1, avatar: 1 }
  ]);
  const [gameSettings, setGameSettings] = useState({
    targetChips: 30
  });
 const [chips, setChips] = useState([]);
  const [currentBet, setCurrentBet] = useState(null);
  const [showBettingDialog, setShowBettingDialog] = useState(false);
  
  // ENDRING 5: Ny state for å håndtere feedback ved feil svar
  const [feedback, setFeedback] = useState(null); // { status: 'correct'/'incorrect', correctPosition: number, card: object }

  const activePlayer = useMemo(() => {
    if (!players || players.length === 0) return null;
    return players[currentPlayerIndex];
  }, [players, currentPlayerIndex]);

 const drawCard = (cards = availableCards) => {
    if (cards.length === 0) { endRound(); return; }
    if (players.length === 0) return;
    
    const [nextCard, ...remaining] = cards;
    setCurrentCard(nextCard);
    setAvailableCards(remaining);
    setShowCardInfo(false);
    setFeedback(null);
    setIsSafePlay(false); // ← LEGG TIL DENNE LINJEN
    
    const playerName = players[currentPlayerIndex]?.name || '';

    if (gameMode === 'single') setGameMessage('Plasser kortet på tidslinjen');
    else if (gameMode === 'knockout') setGameMessage(`${playerName}: Plasser kortet riktig eller du er ute!`);
    else if (gameMode === 'risk') setGameMessage(`${playerName}: Bygg din tidslinje`);
    else setGameMessage(`${playerName}: Plasser kortet på tidslinjen`);
  };

  const initializeGame = () => {
    if (players.length === 0) return;
    
    let shuffled = [...EVENT_PACKS[selectedPack].events].sort(() => Math.random() - 0.5);
    
    if (gameMode === 'risk' || gameMode === 'gamble') {
      setTimelines(players.map(() => []));
      setTimeline([]);
    } else if (gameMode === 'duel') {
      const [firstCard, ...remaining] = shuffled;
      setTimeline([firstCard]);
      shuffled = remaining;
      setTimelines([]);
    } else {
      setTimeline([]);
      setTimelines([]);
    }

    setAvailableCards(shuffled);
    setRoundScores(new Array(players.length).fill(0));
    setEliminatedPlayers([]);
    
    if (gameMode === 'gamble') {
      setChips(new Array(players.length).fill(15));
      // Start hver spillers tidslinje med ett tilfeldig kort
      const startCards = shuffled.slice(0, players.length);
      const remainingAfterStart = shuffled.slice(players.length);
      setTimelines(players.map((_, i) => [startCards[i]]));
      
      setShowBettingDialog(true);
      setCurrentBet(null);
      const [nextCard, ...remaining] = remainingAfterStart;
      setCurrentCard(nextCard);
      setAvailableCards(remaining);
    } else {
      drawCard(shuffled);
    }
   const firstPlayerName = players[0]?.name || '';
  if (gameMode === 'single') {
    setGameMessage('Plasser kortet på tidslinjen');
  } else if (gameMode === 'knockout') {
    setGameMessage(`${firstPlayerName}: Plasser kortet riktig eller du er ute!`);
  } else if (gameMode === 'risk') {
    setGameMessage(`${firstPlayerName}: Bygg din tidslinje`);
  } else if (gameMode === 'duel') {
    setGameMessage(`${firstPlayerName}: Plasser kortet på tidslinjen`);
  }
};
  
  useEffect(() => {
    if (gameState === 'playing' && players.length > 0 && timeline.length === 0 && timelines.length === 0) {
      initializeGame();
    }
  }, [gameState, players]); // eslint-disable-line react-hooks/exhaustive-deps

const placeCard = (position, playerIndex = null) => {
    let targetTimeline;
    const pIndex = playerIndex !== null ? playerIndex : currentPlayerIndex;

    if (gameMode === 'risk' || gameMode === 'gamble') {
      targetTimeline = [...timelines[pIndex]];
    } else {
      targetTimeline = [...timeline];
    }
    
    const tempTimeline = [...targetTimeline];
    tempTimeline.splice(position, 0, currentCard);
    const isCorrect = checkTimelineOrder(tempTimeline);
    
    setShowCardInfo(true);
    
    if (isCorrect) {
      setFeedback({ status: 'correct', card: currentCard });
      if (gameMode === 'risk' || gameMode === 'gamble') {
        const newTimelines = [...timelines];
        newTimelines[pIndex] = tempTimeline;
        setTimelines(newTimelines);
      } else {
        setTimeline(tempTimeline);
      }

      if (gameMode === 'gamble') {
        // Gi dobbelt tilbake
        const newChips = [...chips];
        newChips[currentPlayerIndex] += currentBet * 2;
        setChips(newChips);
        
        setGameMessage(
          <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
            <CheckCircle color="#10b981" /> Riktig! +{currentBet * 2} chips
          </span>
        );
        
        setTimeout(() => {
          // Sjekk om spilleren har vunnet
          if (newChips[currentPlayerIndex] >= (playerConfigs.targetChips || 30)) {
            setGameMessage(`${players[currentPlayerIndex].name} vinner med ${newChips[currentPlayerIndex]} chips!`);
            setTimeout(() => setGameState('finished'), 2000);
            return;
          }
          
          nextPlayer(false);
          if (availableCards.length > 0) {
            const [nextCard, ...remaining] = availableCards;
            setCurrentCard(nextCard);
            setAvailableCards(remaining);
            setShowBettingDialog(true);
            setShowCardInfo(false);
            setFeedback(null);
          } else {
            setGameState('finished');
          }
        }, 1500);
        return;
      }

      const newRoundScores = [...roundScores];
      newRoundScores[currentPlayerIndex]++;
      setRoundScores(newRoundScores);
      
      // For single og duel mode, oppdater totalscoren direkte
      if (gameMode === 'single' || gameMode === 'duel') {
        const newScores = [...scores];
        newScores[currentPlayerIndex]++;
        setScores(newScores);
      }
      
      setGameMessage(
          <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <CheckCircle color="#10b981" /> Riktig!
          </span>
      );
      
setTimeout(() => {
  if (isSafePlay) {
    const finalRoundScore = roundScores[currentPlayerIndex] + 1;
    setGameMessage(`${players[currentPlayerIndex].name} sikret ${finalRoundScore} poeng!`);
    passRound(true);
    setIsSafePlay(false);
  } else {
    const currentRoundScore = roundScores[currentPlayerIndex] + 1; // Legg til denne
    if (gameMode === 'risk' && currentRoundScore >= 10) { // Endre til currentRoundScore
      passRound();
    } else if (gameMode === 'risk' || gameMode === 'single') {
      drawCard();
    } else {
      nextPlayer(true);
    }
  }
}, 1500);

    } else {
      const correctPosition = targetTimeline.filter(card => {
    if (card.year < currentCard.year) return true;
    if (card.year > currentCard.year) return false;
    
    // Samme år, sjekk måned
    const monthCard = card.month || 0;
    const monthCurrent = currentCard.month || 0;
    if (monthCard < monthCurrent) return true;
    if (monthCard > monthCurrent) return false;

    // Samme måned, sjekk dag
    const dayCard = card.day || 0;
    const dayCurrent = currentCard.day || 0;
    return dayCard < dayCurrent;
}).length;

     // LEGG TIL 'clickedPosition'
setFeedback({ status: 'incorrect', correctPosition, card: currentCard, clickedPosition: position });
      
      const prevCard = targetTimeline[correctPosition - 1];
      const nextCard = targetTimeline[correctPosition];
      let feedbackText = 'Feil!';
if (prevCard && nextCard) {
  feedbackText = `Feil! Riktig plassering var mellom ${formatDateForCard(prevCard)} og ${formatDateForCard(nextCard)}.`;
} else if (prevCard) {
  feedbackText = `Feil! Riktig plassering var etter ${formatDateForCard(prevCard)}.`;
} else if (nextCard) {
  feedbackText = `Feil! Riktig plassering var før ${formatDateForCard(nextCard)}.`;
}

      setGameMessage(
        <span style={{display: 'flex', alignItems: 'center', gap: '8px', color: '#ef4444'}}>
            <XCircle /> {feedbackText}
        </span>
      );

      const WRONG_ANSWER_TIMEOUT = 4000;
      const nextAction = () => {
        if (gameMode === 'single') {
            setGameMessage(`Spillet er over. Du klarte ${scores[0]} kort.`);
            setTimeout(() => setGameState('finished'), 2000);
        } else if (gameMode === 'duel') {
            // Gi poeng til motspillerne
            const newRoundScores = [...roundScores];
            const newScores = [...scores];
            players.forEach((_, i) => { 
              if (i !== currentPlayerIndex && !eliminatedPlayers.includes(i)) {
                newRoundScores[i]++;
                newScores[i]++;
              }
            });
            setRoundScores(newRoundScores);
            setScores(newScores);
            
            // Legg kortet tilbake i bunken og stokk
            const newShuffledDeck = [...availableCards, currentCard].sort(() => Math.random() - 0.5);
            setAvailableCards(newShuffledDeck);
            
            nextPlayer(true);
       } else if (gameMode === 'knockout') {
            const newEliminated = [...eliminatedPlayers, currentPlayerIndex];
            setEliminatedPlayers(newEliminated);
            setGameMessage(`${players[currentPlayerIndex].name} er ute!`);
            if (newEliminated.length >= players.length - 1) endRound(); else nextPlayer(true);
        } else if (gameMode === 'gamble') {
            // Mist chips
            const newChips = [...chips];
            newChips[currentPlayerIndex] -= currentBet;
            setChips(newChips);
            
            // Sjekk om spilleren er tom for chips
            if (newChips[currentPlayerIndex] <= 0) {
              setGameMessage(`${players[currentPlayerIndex].name} er tom for chips!`);
              setTimeout(() => setGameState('finished'), 2000);
              return;
            }
            
            setTimeout(() => {
              nextPlayer(false);
              if (availableCards.length > 0) {
                const [nextCard, ...remaining] = availableCards;
                setCurrentCard(nextCard);
                setAvailableCards(remaining);
                setShowBettingDialog(true);
                setShowCardInfo(false);
                setFeedback(null);
              } else {
                setGameState('finished');
              }
            }, 1500);
         } else { // Risk mode
  const newRoundScores = [...roundScores];
  newRoundScores[currentPlayerIndex] = 0;
  setRoundScores(newRoundScores);
  
  const newTimelines = [...timelines];

  // --- NY, FORBEDRET LOGIKK ---

  // 1. Hent kortene som skal returneres fra spillerens tidslinje.
  const cardsToReturn = timelines[currentPlayerIndex];

  // 2. Legg de returnerte kortene tilbake i bunken og stokk den på nytt.
  const newShuffledDeck = [...availableCards, ...cardsToReturn].sort(() => Math.random() - 0.5);
  setAvailableCards(newShuffledDeck);

  // 3. Tøm spillerens tidslinje helt.
  newTimelines[currentPlayerIndex] = [];

  // --- SLUTT PÅ NY LOGIKK ---
  
  setTimelines(newTimelines);
  nextPlayer(true);
}
      };
      
      setTimeout(nextAction, WRONG_ANSWER_TIMEOUT);
    }
  };

  const checkTimelineOrder = (t) => {
  for (let i = 0; i < t.length - 1; i++) {
    const cardA = t[i];
    const cardB = t[i+1];
    
    if (cardA.year > cardB.year) return false;
    if (cardA.year === cardB.year) {
      // Måned er 1-12, 0 eller undefined betyr "først på året"
      const monthA = cardA.month || 0;
      const monthB = cardB.month || 0;
      if (monthA > monthB) return false;
      if (monthA === monthB) {
        // Dag er 1-31, 0 eller undefined betyr "først i måneden"
        const dayA = cardA.day || 0;
        const dayB = cardB.day || 0;
        if (dayA > dayB) return false;
      }
    }
  }
  return true;
};
  
const nextPlayer = (shouldDrawCard = false) => {
  let nextIndex = (currentPlayerIndex + 1) % players.length;

  if (['duel', 'knockout'].includes(gameMode)) {
    let attempts = 0;
    while (eliminatedPlayers.includes(nextIndex) && attempts < players.length) {
      nextIndex = (nextIndex + 1) % players.length;
      attempts++;
    }
  }

  setCurrentPlayerIndex(nextIndex);

  if (shouldDrawCard) {
    const playerName = players[nextIndex]?.name || '';
    
    if (gameMode === 'knockout') {
      setGameMessage(`${playerName}: Plasser kortet riktig eller du er ute!`);
    } else if (gameMode === 'risk') {
      setGameMessage(`${playerName}: Bygg din tidslinje`);
    } else if (gameMode === 'gamble') {
      setGameMessage(`${playerName}: Satse 1-3 chips eller fold`);
    } else {
      setGameMessage(`${playerName}: Plasser kortet på tidslinjen`);
    }
    
    drawCard();
  }
};

 const passRound = (wasSafePlay = false) => {
  const newScores = [...scores];
  // Hvis det var et sikkert spill, er poengene allerede i roundScores + 1
  const scoreToAdd = wasSafePlay ? roundScores[currentPlayerIndex] + 1 : roundScores[currentPlayerIndex];
  
  newScores[currentPlayerIndex] += scoreToAdd;
  setScores(newScores);
  
  if (!wasSafePlay) {
    setGameMessage(`${players[currentPlayerIndex].name} stopper og sikrer ${scoreToAdd} poeng!`);
  }
  
  const newRoundScores = [...roundScores];
  newRoundScores[currentPlayerIndex] = 0;
  setRoundScores(newRoundScores);

  setTimeout(() => { nextPlayer(true); }, 2000);
};
  
  const endRound = () => {
    if (gameMode === 'knockout') {
      const winner = players.find((_, i) => !eliminatedPlayers.includes(i));
      if (winner) setGameMessage(`${winner.name} vinner!`);
      setTimeout(() => setGameState('finished'), 2000);
      return;
    }
    
    const newScores = [...scores];
    for (let i = 0; i < players.length; i++) newScores[i] += roundScores[i];
    setScores(newScores);
    
    if (Math.max(...newScores) >= 10 || roundNumber >= 5) {
      setGameState('finished');
      return;
    }
    
    setRoundNumber(roundNumber + 1);
    setGameMessage(`Runde ${roundNumber} ferdig! Starter runde ${roundNumber + 1}...`);
    setTimeout(() => initializeGame(), 3000);
  };
  
  const resetGame = () => {
    setGameState('setup');
    setPlayers([]);
    setScores([]);
    setRoundScores([]);
    setTimeline([]);
    setTimelines([]);
    setCurrentCard(null);
    setRoundNumber(1);
    setEliminatedPlayers([]);
  };
  
 const handleBet = (betAmount) => {
    if (betAmount === 0) {
      // Fold
      setShowBettingDialog(false);
      setCurrentBet(0);
      setGameMessage(`${players[currentPlayerIndex].name} foldet`);
      setTimeout(() => {
        nextPlayer(false);
        if (availableCards.length > 0) {
          setShowBettingDialog(true);
        }
      }, 1500);
    } else {
      setCurrentBet(betAmount);
      setShowBettingDialog(false);
      setShowCardInfo(false);
      setGameMessage(`${players[currentPlayerIndex].name} satser ${betAmount} chips`);
    }
  };

  const startGame = () => {
  let playerData;

  if (gameMode === 'single') {
    // Sikrer at også single-player har begge farger
    playerData = [{
      name: 'Du',
      color: PLAYER_COLORS[0],
      highlightColor: PLAYER_HIGHLIGHT_COLORS[0],
      avatar: PLAYER_AVATARS[0]
    }];
  } else {
    // Sikrer at flerspiller-objektene blir laget riktig
    playerData = playerConfigs.map((config, i) => ({
      name: config.name || `Spiller ${i + 1}`,
      color: PLAYER_COLORS[config.color],
      highlightColor: PLAYER_HIGHLIGHT_COLORS[config.color],
      avatar: PLAYER_AVATARS[config.avatar]
    }));
  }
  
  // Denne koden vil nå fungere fordi playerData er garantert å være en liste
 setPlayers(playerData);
  setScores(new Array(playerData.length).fill(0));
  setCurrentPlayerIndex(0);
  setGameState('playing');
};
  
if (gameState === 'setup') {
  return (
    <>
      {/* GlobalStyle er lagt til for å style scrollebaren */}
      <GlobalStyle />
     <PlayerSetup 
        gameMode={gameMode} 
        setGameMode={setGameMode} 
        playerConfigs={playerConfigs} 
        setPlayerConfigs={setPlayerConfigs} 
        onStart={startGame} 
        selectedPack={selectedPack} 
        setSelectedPack={setSelectedPack}
        gameSettings={gameSettings}
        setGameSettings={setGameSettings}
      />
    </>
  );
}

if (gameState === 'finished') {
  const sortedPlayers = players.map((player, i) => ({ 
    player, 
    score: gameMode === 'gamble' ? chips[i] : scores[i] 
  })).sort((a, b) => b.score - a.score);
  const winner = sortedPlayers.length > 0 ? sortedPlayers[0] : null;

  return (
    <>
      {/* GlobalStyle er lagt til også her */}
      <GlobalStyle />
      <div style={{
        minHeight: '100vh', backgroundColor: '#f1f5f9', display: 'flex',
        alignItems: 'center', justifyContent: 'center', padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          padding: '32px', maxWidth: '500px', width: '100%', textAlign: 'center'
        }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#1e293b', margin: '0 0 24px 0' }}>
            Spillet er ferdig!
          </h1>
          {winner && (
            <div style={{ marginBottom: '24px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#059669', margin: '0 0 12px 0' }}>
                {gameMode === 'single' ? `Du klarte ${scores[0]} kort!` : gameMode === 'gamble' ? `Vinner: ${winner.player.name} med ${chips[currentPlayerIndex]} chips!` : `Vinner: ${winner.player.name}!`}
              </h2>
              {gameMode !== 'single' && (
                <div style={{
                  width: '56px', height: '56px', borderRadius: '50%', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', color: 'white',
                  fontSize: '28px', margin: '0 auto', backgroundColor: winner.player.color
                }}>
                  {winner.player.avatar}
                </div>
              )}
            </div>
          )}
          {gameMode !== 'single' && (
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#475569', margin: '0 0 12px 0' }}>
                Sluttresultat
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {sortedPlayers.map((playerData, index) => (
                  <div key={index} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    backgroundColor: index === 0 ? '#fef3c7' : '#f8fafc',
                    padding: '12px 16px', borderRadius: '8px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#64748b', minWidth: '24px' }}>
                        #{index + 1}
                      </div>
                      <div style={{
                        width: '28px', height: '28px', borderRadius: '50%', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', color: 'white',
                        fontSize: '14px', backgroundColor: playerData.player.color
                      }}>
                        {playerData.player.avatar}
                      </div>
                      <div style={{ fontWeight: '600', fontSize: '15px', color: '#1e293b' }}>
                        {playerData.player.name}
                      </div>
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b' }}>
                      {gameMode === 'gamble' ? `${chips[players.indexOf(playerData.player)]} 💰` : `${playerData.score}p`}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <button onClick={resetGame} style={{
              width: '100%', backgroundColor: '#3b82f6', color: 'white', padding: '12px',
              borderRadius: '8px', fontWeight: '600', fontSize: '14px', border: 'none', cursor: 'pointer'
            }}>
            Spill igjen
          </button>
        </div>
      </div>
    </>
  );
}

return (
   <> {/* 👈 1. Legg til et fragment her */}
     <GlobalStyle /> {/* 👈 2. Legg til GlobalStyle-komponenten */}
     <div style={{
         minHeight: '100vh',
         // 👇 3. Bytt ut de gamle bakgrunnslinjene med denne:
         background: EVENT_PACKS[selectedPack]?.backgroundStyle || '#f1f5f9',
         paddingTop: '88px',
         paddingBottom: '250px',
         position: 'relative'
       }}>

        {EVENT_PACKS[selectedPack]?.background && (
          <div 
            className="category-background"
            dangerouslySetInnerHTML={{ __html: EVENT_PACKS[selectedPack].background }}
          />
        )}
        {showBettingDialog && gameMode === 'gamble' && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 300
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '24px',
              maxWidth: '400px',
              boxShadow: '0 10px 25px rgba(0,0,0,0.3)'
            }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600', color: '#1e293b' }}>
                {players[currentPlayerIndex]?.name}, hva vil du gjøre?
              </h3>
              <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#64748b' }}>
                Du har {chips[currentPlayerIndex]} chips
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <button
                  onClick={() => handleBet(0)}
                  style={{
                    padding: '12px',
                    backgroundColor: '#64748b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    gridColumn: '1 / -1'
                  }}
                >
                  Fold
                </button>
                {[1, 2, 3].map(bet => (
                  <button
                    key={bet}
                    onClick={() => handleBet(bet)}
                    disabled={chips[currentPlayerIndex] < bet}
                    style={{
                      padding: '12px',
                      backgroundColor: chips[currentPlayerIndex] < bet ? '#e2e8f0' : '#3b82f6',
                      color: chips[currentPlayerIndex] < bet ? '#94a3b8' : 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontWeight: '600',
                      cursor: chips[currentPlayerIndex] < bet ? 'not-allowed' : 'pointer'
                    }}
                  >
                    Satse {bet} 💰
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      {/* Sticky header */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, backgroundColor: 'white',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: '12px 20px', zIndex: 100
      }}>
        <div style={{
          maxWidth: '1400px', margin: '0 auto', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <div>
                 <h1 style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', margin: '0' }}>Alle tiders tidslinje</h1>
                 <p style={{ fontSize: '12px', color: '#64748b', margin: '0' }}>
                   {gameMode.charAt(0).toUpperCase() + gameMode.slice(1)}
                   {gameMode !== 'single' && ` · Runde ${roundNumber}`}
                 </p>
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              {players.map((player, index) => {
                const isActive = index === currentPlayerIndex;
                return (
                  <div key={index} style={{
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 12px',
  borderRadius: '99px',
  backgroundColor: isActive ? player.highlightColor : '#f8fafc',
  color: isActive ? 'white' : '#1e293b',
  // KORRIGERT LINJE: Bruker 'isActive' og riktig farge
  border: `2px solid ${isActive ? player.highlightColor : '#e2e8f0'}`,
  opacity: eliminatedPlayers.includes(index) ? 0.4 : 1,
  transform: isActive ? 'scale(1.1)' : 'scale(1)',
  transition: 'all 0.3s ease-in-out',
  boxShadow: isActive ? `0 4px 12px ${player.highlightColor}55` : 'none',
}}
                  >
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', display: 'flex',
                      alignItems: 'center', justifyContent: 'center', fontSize: '14px',
                      backgroundColor: 'rgba(255,255,255,0.2)'
                    }}>
                      {player.avatar}
                    </div>
                    <div style={{ fontWeight: '600' }}>{player.name}</div>
                   <div style={{ fontWeight: '700', marginLeft: '4px' }}>
                      {gameMode === 'knockout' ? '✓' : gameMode === 'gamble' ? `${chips[index]} 💰` : gameMode === 'risk' ? `${scores[index]}${roundScores[index] > 0 ? ` (+${roundScores[index]})` : ''}` : `${scores[index]}`}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <button onClick={resetGame} style={{
              padding: '6px 12px', backgroundColor: '#64748b', color: 'white', borderRadius: '6px',
              border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center',
              gap: '4px', fontSize: '13px', fontWeight: '500'
          }}>
            <RotateCcw size={14} /> Nytt
          </button>
        </div>
      </div>

      <div style={{
        position: 'fixed', top: '72px', left: 0, right: 0, zIndex: 90,
        display: 'flex', justifyContent: 'center',
        padding: '0 16px',
        }}>
          <div style={{
  display: 'inline-flex', alignItems: 'center',
  backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  padding: '12px 16px', fontSize: '14px', fontWeight: '500', color: '#475569'
}}>
  {currentCard && !showCardInfo ? (
    `${activePlayer?.name}: ${
      gameMode === 'knockout' ? 'Plasser kortet riktig eller du er ute!' :
      gameMode === 'risk' ? 'Bygg din tidslinje' :
      gameMode === 'gamble' ? 'Satse 1-3 chips eller fold' :
      'Plasser kortet på tidslinjen'
    }`
  ) : gameMessage}
</div>
      </div>
      
{currentCard && !showCardInfo && (
  <div style={{
    position: 'fixed',
    bottom: gameMode === 'risk' ? '20px' : '100px',
    left: 0,
    right: 0,
    zIndex: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '20px',
    pointerEvents: 'none'
  }}>
    <div style={{
      padding: '16px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: `0 0 0 4px ${activePlayer?.highlightColor || '#cbd5e1'}, 0 5px 15px rgba(0,0,0,0.2)`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      pointerEvents: 'auto',
      width: '220px' // Justert bredde for å passe knappen
    }}>
      <div style={{ fontSize: '14px', fontWeight: '600', color: '#475569' }}>
        {activePlayer?.name}, plasser dette kortet:
      </div>
      <div style={{
        backgroundColor: getCategoryColor(currentCard.category),
        color: 'white',
        padding: '12px',
        borderRadius: '6px',
        textAlign: 'center',
        width: '100%', // Fyller bredden
        minHeight: '120px',
        display: 'flex',
        // ... resten av kort-stylingen
      }}>
        <div style={{
          fontSize: '20px',
          fontWeight: '500',
          lineHeight: '1.3',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {currentCard.event}
        </div>
      </div>

      {/* NY MODUS-VEKSLER-KNAPP */}
{gameMode === 'risk' && (
  <button 
    onClick={() => setIsSafePlay(!isSafePlay)}
    style={{
      width: '100%',
      marginTop: '8px',
      padding: '10px',
      // Blir grønn når aktiv, ellers nøytral grå
      backgroundColor: isSafePlay ? '#16a34a' : '#64748b', 
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontWeight: '600',
      fontSize: '14px',
      cursor: 'pointer',
      transition: 'all 0.2s',
    }}
  >
    Plasser kort og avslutt tur
  </button>
)}
    </div>
  </div>
)}

       {/* Tidslinje(r) */}
      <div style={{ maxWidth: '1400px', margin: '16px auto', padding: '0 16px' }}>
        {(gameMode === 'risk' || gameMode === 'gamble') ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {players.map((player, playerIndex) => (
              <div key={playerIndex} style={{
                backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                padding: '16px', border: playerIndex === currentPlayerIndex ? `2px solid ${player.highlightColor}` : '1px solid #e2e8f0',
                opacity: eliminatedPlayers.includes(playerIndex) ? 0.5 : 1
              }}>
                <div style={{
                  fontSize: '14px', fontWeight: '600', color: '#1e293b', marginBottom: '12px',
                  display: 'flex', alignItems: 'center', gap: '8px'
                }}>
                  <div style={{
                    width: '24px', height: '24px', borderRadius: '50%', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', color: 'white',
                    fontSize: '12px', backgroundColor: player.color
                  }}>
                    {player.avatar}
                  </div>
                  {player.name}s tidslinje ({timelines[playerIndex]?.length || 0} kort)
                </div>
                <div 
  className="timeline-scroll-container" 
  style={{
                  display: 'flex', gap: '12px', alignItems: 'center',
                  overflowX: 'auto', padding: '16px 8px', minHeight: '145px'
                }}>
                  {playerIndex === currentPlayerIndex && !showCardInfo && <EventCard isPlaceholder onClick={() => placeCard(0, playerIndex)} />}
{feedback?.status === 'incorrect' && playerIndex === currentPlayerIndex && feedback.clickedPosition === 0 && (
    <EventCard card={feedback.card} feedback="incorrect" />
)}
{timelines[playerIndex]?.map((card, index) => (
  <React.Fragment key={index}>
    <EventCard 
      card={card}
                        isCurrent={showCardInfo && feedback?.card?.event === card.event} 
                        feedback={feedback && feedback.card.event === card.event ? feedback.status : null}
                      />
                       {/* LEGG TIL DENNE BLOKKEN for å vise feilplassert kort i Risk-modus */}
    {feedback?.status === 'incorrect' && playerIndex === currentPlayerIndex && feedback.clickedPosition === index + 1 && (
        <EventCard card={feedback.card} feedback="incorrect" />
    )}
                      {feedback?.status === 'incorrect' && playerIndex === currentPlayerIndex && feedback.correctPosition === index + 1 && (
                        <div style={{ minWidth: '100px', height: '110px', border: '3px dashed #10b981', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981', fontSize: '12px', textAlign: 'center', backgroundColor: '#f0fdf4', flexShrink: 0 }}>Riktig<br/>plass her</div>
                      )}
                      {playerIndex === currentPlayerIndex && !showCardInfo && <EventCard isPlaceholder onClick={() => placeCard(index + 1, playerIndex)} />}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: '16px'
          }}>
            <div
      className="timeline-scroll-container"
      style={{
              display: 'flex', gap: '12px', alignItems: 'center',
              overflowX: 'auto', padding: '16px 8px', minHeight: '145px'
            }}>
             {/* Håndterer feilplassering helt i starten */}
{feedback?.status === 'incorrect' && feedback.clickedPosition === 0 && (
    <EventCard card={feedback.card} feedback="incorrect" />
)}

{!showCardInfo && <EventCard isPlaceholder onClick={() => placeCard(0)} />}
{timeline.map((card, index) => (
  <React.Fragment key={index}>
    <EventCard 
      card={card}  
                    isCurrent={showCardInfo && feedback?.card?.event === card.event} 
                    feedback={feedback && feedback.card.event === card.event ? feedback.status : null}
                  />
                   {feedback?.status === 'incorrect' && feedback.clickedPosition === index + 1 && (
        <EventCard card={feedback.card} feedback="incorrect" />
    )}
                  {feedback?.status === 'incorrect' && feedback.correctPosition === index + 1 && (
                      <div style={{
                          minWidth: '100px', height: '110px', border: '3px dashed #10b981',
                          borderRadius: '8px', display: 'flex', alignItems: 'center', 
                          justifyContent: 'center', color: '#10b981', fontSize: '12px', textAlign: 'center',
                          backgroundColor: '#f0fdf4', flexShrink: 0
                      }}>
                          Riktig<br/>plass her
                      </div>
                  )}
                  {!showCardInfo && <EventCard isPlaceholder onClick={() => placeCard(index + 1)} />}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
     </> 
  );
};

export default TimelineGame;